import * as React from 'react';
import { useMemo } from 'react';
import Card from '@mui/material/Card';
import { DynamicQuestionnaire } from 'benchmarking-domain/dynamic-questionnaire';
import { PermissionsHelper } from 'benchmarking-domain/permissions-helper';
import Project from 'benchmarking-domain/project';
import ProjectProgressStatistics from 'benchmarking-domain/project-progress-statistics';
import ProjectSection from 'benchmarking-domain/project-section';
import Questionnaire from 'benchmarking-domain/questionnaire';

import { useUser } from '../../../hooks/use-user';
import { QuestionnaireSectionAccordion } from './questionnaire-section-accordion';

const QuestionnaireSectionAccordionMemo = React.memo(QuestionnaireSectionAccordion);

export interface QuestionnaireFormProps {
  organisationId: string;
  project: Project;
  projectSections: ProjectSection[] | undefined;
  projectProgressStatistics?: ProjectProgressStatistics;
  questionnaire: Questionnaire;
  dynamicQuestionnaires?: DynamicQuestionnaire[];
  usersEmailToNameMap?: Map<string, string | undefined>;
}

export function QuestionnaireForm({
  organisationId,
  project,
  projectSections,
  projectProgressStatistics,
  questionnaire,
  dynamicQuestionnaires,
}: QuestionnaireFormProps): React.JSX.Element {
  const { user } = useUser();

  const globalVariables = useMemo(() => {
    return {
      technology: project.technology,
    };
  }, [project]);

  return (
    <Card>
      {questionnaire.sections
        .filter((s) => s.technologyFilter?.some((t) => t === project.technology) ?? true)
        .filter((s) => PermissionsHelper.hasUserAtLeastRole(`sectionManager_${s.id}`, user, project))
        .map((section) => {
          return (
            <QuestionnaireSectionAccordionMemo
              key={section.id}
              organisationId={organisationId}
              projectId={project.id}
              questionnaireSection={section}
              dynamicQuestionnaires={dynamicQuestionnaires}
              numberOfInputsProvided={projectProgressStatistics?.countInSections?.[section.id] ?? 0}
              totalNumberOfInputs={projectProgressStatistics?.totalInSections?.[section.id] ?? 0}
              globalVariables={globalVariables}
              project={project}
              projectSections={projectSections}
            />
          );
        })}
    </Card>
  );
}
